var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	3783: () => (loadSingletonVersion("default", "vue", true, [1,3,5,0], () => (() => (__webpack_require__(785))))),
	6592: () => (loadSingletonVersion("default", "vue", true, [1,3,0,0], () => (() => (__webpack_require__(785))))),
	8336: () => (loadSingletonVersion("default", "vue", true, [1,3,5,18], () => (() => (__webpack_require__(785))))),
	8509: () => (loadStrictVersion("default", "graphql", false, [1,16,11,0], () => (__webpack_require__.e(1547).then(() => (() => (__webpack_require__(1547))))))),
	9259: () => (loadStrictVersion("default", "@vue/apollo-composable", false, [1,4,2,2], () => (Promise.all([__webpack_require__.e(5933), __webpack_require__.e(4907)]).then(() => (() => (__webpack_require__(5933))))))),
	2102: () => (loadStrictVersion("default", "@automapper/core", false, [1,8,8,1], () => (__webpack_require__.e(7872).then(() => (() => (__webpack_require__(7872))))))),
	7788: () => (loadStrictVersion("default", "@vueuse/core", false, [1,10,11,1], () => (Promise.all([__webpack_require__.e(3115), __webpack_require__.e(4907)]).then(() => (() => (__webpack_require__(3115))))))),
	3121: () => (loadSingletonVersion("default", "vue", true, [1,3,3,0], () => (() => (__webpack_require__(785))))),
	2756: () => (loadSingletonVersion("default", "element-plus", false, [4,2,13,7], () => (Promise.all([__webpack_require__.e(6429), __webpack_require__.e(7631), __webpack_require__.e(9127)]).then(() => (() => (__webpack_require__(7631))))))),
	3932: () => (loadSingletonVersion("default", "vue", true, [4,3,5,13], () => (() => (__webpack_require__(785))))),
	5433: () => (loadStrictVersion("default", "@element-plus/icons-vue", false, [1,2,3,1], () => (Promise.all([__webpack_require__.e(8647), __webpack_require__.e(4774)]).then(() => (() => (__webpack_require__(8647))))))),
	7886: () => (loadSingletonVersion("default", "vue-i18n", true, [4,10,0,5], () => (() => (__webpack_require__(1999))))),
	4774: () => (loadSingletonVersion("default", "vue", true, [1,3,2,0], () => (() => (__webpack_require__(785))))),
	7698: () => (loadStrictVersion("default", "@element-plus/icons-vue", false, [1,2,3,1], () => (Promise.all([__webpack_require__.e(8548), __webpack_require__.e(4774)]).then(() => (() => (__webpack_require__(8548))))))),
	2715: () => (loadSingletonVersion("default", "vue", true, [1,3,4,30], () => (() => (__webpack_require__(785))))),
	7126: () => (loadSingletonVersion("default", "element-plus", false, [1,2,7,6], () => (Promise.all([__webpack_require__.e(6429), __webpack_require__.e(8204), __webpack_require__.e(4774), __webpack_require__.e(245)]).then(() => (() => (__webpack_require__(8204))))))),
	4907: () => (loadSingletonVersion("default", "vue", true, [,[1,2,6,0],[1,3,0,0,,0],1], () => (() => (__webpack_require__(785))))),
	2317: () => (loadSingletonVersion("default", "vue", true, [1,3,5,13], () => (() => (__webpack_require__(785))))),
	245: () => (loadStrictVersion("default", "@vueuse/core", false, [1,10,11,1], () => (Promise.all([__webpack_require__.e(4984), __webpack_require__.e(4907)]).then(() => (() => (__webpack_require__(4984))))))),
	1642: () => (loadStrictVersion("default", "@element-plus/icons-vue", false, [1,2,3,1], () => (Promise.all([__webpack_require__.e(3852), __webpack_require__.e(4774)]).then(() => (() => (__webpack_require__(3852))))))),
	8196: () => (loadStrictVersion("default", "@vueuse/core", false, [1,10,11,1], () => (Promise.all([__webpack_require__.e(3027), __webpack_require__.e(2317)]).then(() => (() => (__webpack_require__(3027))))))),
	1551: () => (loadSingletonVersion("default", "vue-i18n", true, [1,11,1,11], () => (() => (__webpack_require__(9405))))),
	9330: () => (loadStrictVersion("default", "@dsc/components", false, [1,2,4,0], () => (Promise.all([__webpack_require__.e(8642), __webpack_require__.e(7788), __webpack_require__.e(3121), __webpack_require__.e(8848)]).then(() => (() => (__webpack_require__(8642))))))),
	4728: () => (loadSingletonVersion("default", "vue-router", true, [1,4,5,1], () => (() => (__webpack_require__(4965))))),
	6079: () => (loadSingletonVersion("default", "pinia", false, [4,2,3,1], () => (Promise.all([__webpack_require__.e(810), __webpack_require__.e(4907)]).then(() => (() => (__webpack_require__(810))))))),
	4531: () => (loadSingletonVersion("default", "@scp/frontend-common", false, [1,1,13,1], () => (Promise.all([__webpack_require__.e(9970), __webpack_require__.e(9996), __webpack_require__.e(7698), __webpack_require__.e(6426)]).then(() => (() => (__webpack_require__(9970))))))),
	8420: () => (loadStrictVersion("default", "@automapper/pojos", false, [1,8,8,1], () => (__webpack_require__.e(6729).then(() => (() => (__webpack_require__(9110))))))),
	3977: () => (loadStrictVersion("default", "uuid", false, [1,9,0,1], () => (__webpack_require__.e(9308).then(() => (() => (__webpack_require__(9308))))))),
	9166: () => (loadStrictVersion("default", "exceljs", false, [1,4,4,0], () => (__webpack_require__.e(4974).then(() => (() => (__webpack_require__(4974)))))))
};
const initialConsumes = [3783,6592];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		const factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
const chunkMapping = {
	"245": [
		245
	],
	"417": [
		3977,
		9166
	],
	"1378": [
		8420
	],
	"2102": [
		2102
	],
	"2317": [
		2317
	],
	"3121": [
		3121
	],
	"4531": [
		4531
	],
	"4728": [
		4728
	],
	"4774": [
		4774
	],
	"4907": [
		4907
	],
	"6426": [
		2715,
		7126
	],
	"6871": [
		8509,
		9259
	],
	"7290": [
		1551,
		9330
	],
	"7698": [
		7698
	],
	"7788": [
		7788
	],
	"8336": [
		8336
	],
	"8792": [
		3783,
		6592
	],
	"8848": [
		2756,
		3932,
		5433,
		7886
	],
	"9069": [
		6079
	],
	"9127": [
		1642,
		8196
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}